import { createAction } from '@reduxjs/toolkit';
export var getCities = createAction('userAddress/getCities');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/redux/UserAddressState/UserAddressState.actions.js
// module id = 891
// module chunks = 11